<template>
  <div class="content">
    <div class="holder container">
      <ValidationObserver ref="form">
        <!-- <button @click="saveData">test</button> -->
        <form @submit.prevent="onClickAction">
          <div class="content-body col-md-10 col-xl-7 col-12 p-0">
            <div class="form-group row-text-index">
              <span class="font-weight-bold">
                {{ $t('front_end.a035.label.order_number') }} :
                {{ ordererInformation.orderNo }}
              </span>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.name') }}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <div class="col-5 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a035.placeholder.first_name')"
                    rules="required|max:255|full_size"
                    v-slot="{}"
                    vid="first_name"
                    ref="first_name"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a035.placeholder.first_name')"
                      v-model.trim="ordererInformation.last_name"
                      maxlength="255"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-5 offset-2 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a035.placeholder.last_name')"
                    rules="required|max:255|full_size"
                    v-slot="{}"
                    vid="last_name"
                    ref="last_name"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a035.placeholder.last_name')"
                      v-model.trim="ordererInformation.first_name"
                      maxlength="255"
                    />
                  </ValidationProvider>
                </div>

                <p class="inline-error-noti" v-if="errors.name">
                  {{ errors.name }}
                </p>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.name_furigana') }}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <div class="col-5 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a035.placeholder.first_name_furigana')"
                    rules="required|max:255|full_size_katakana"
                    v-slot="{}"
                    ref="first_name_furigana"
                  >
                    <input
                      maxlength="255"
                      type="text"
                      class="form-control"
                      :placeholder="
                        $t('front_end.a035.placeholder.first_name_furigana')
                      "
                      v-model.trim="ordererInformation.last_name_kana"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-5 none-padding offset-2">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a035.placeholder.last_name_furigana')"
                    rules="required|max:255|full_size_katakana"
                    v-slot="{}"
                    ref="last_name_furigana"
                  >
                    <input
                      maxlength="255"
                      type="text"
                      class="form-control"
                      :placeholder="
                        $t('front_end.a035.placeholder.last_name_furigana')
                      "
                      v-model.trim="ordererInformation.first_name_kana"
                    />
                  </ValidationProvider>
                </div>
                <p class="inline-error-noti" v-if="errors.furigana_name">
                  {{ errors.furigana_name }}
                </p>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.email') }}</span>
                <span class="text-danger" v-if="!isShopMode">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.email')"
                  rules="required|email|max:254"
                  v-slot="{ errors, failedRules }"
                  v-if="!isShopMode"
                  class="w100"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.email"
                  />

                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.email"
                    >{{ $t('front_end.a035.validate.email_format') }}</span
                  >
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.max"
                    >{{ $t('front_end.a035.label.email')
                    }}{{ $t('front_end.a035.validate.length') }}</span
                  >
                  <span
                    class="error-msg message-error-size"
                    v-else-if="errors[0]"
                    >{{ errors[0] }}</span
                  >
                </ValidationProvider>
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.email')"
                  rules="email|max:254"
                  v-slot="{ errors, failedRules }"
                  v-else
                  class="w100"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.email"
                  />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.email"
                    >{{ $t('front_end.a035.validate.email_format') }}</span
                  >
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.max"
                    >{{ $t('front_end.a035.label.email')
                    }}{{ $t('front_end.a035.validate.length') }}</span
                  >
                  <span
                    class="error-msg message-error-size"
                    v-else-if="errors[0]"
                    >{{ errors[0] }}</span
                  >
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.phone_number') }}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberFirst"
                  ref="phoneNumberFirst"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|min:2|max:5|half_size_number"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{}"
                >
                  <input
                    :type="dynamicNumberType"
                    class="form-control text-center pd-0 auto-next"
                    maxlength="5"
                    :pattern="dynamicPattern"
                    v-model.trim="ordererInformation.phone_number_first"
                    id="phone_number_first"
                  />
                </ValidationProvider>

                <span class="line-zip"></span>
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberSecond"
                  ref="phoneNumberSecond"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|min:1|max:4|half_size_number"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{}"
                >
                  <input
                    :type="dynamicNumberType"
                    class="form-control text-center pd-0 auto-next"
                    maxlength="4"
                    :pattern="dynamicPattern"
                    v-model.trim="ordererInformation.phone_number_second"
                    id="phone_number_second"
                  />
                </ValidationProvider>
                <span class="line-zip"></span>
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberThird"
                  ref="phoneNumberThird"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|max:4|half_size_number"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{}"
                >
                  <input
                    :type="dynamicNumberType"
                    class="form-control text-center pd-0 auto-next"
                    maxlength="4"
                    :pattern="dynamicPattern"
                    v-model.trim="ordererInformation.phone_number_third"
                    id="phone_number_third"
                  />
                </ValidationProvider>
                <div
                  class="error-msg message-error-size"
                  v-if="errors.phoneNumber"
                >
                  {{ errors.phoneNumber }}
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row-custom mb-2">
                <div class="col-2">
                  <span>{{
                    $t('front_end.a035.label.ship_address.ship_address')
                  }}</span>
                </div>
                <div class="col-10 pr-0">
                  <span>{{
                    $t('front_end.a035.label.ship_address.postal_code')
                  }}</span>
                  <span class="text-danger" v-if="!isShopMode">*</span>
                </div>
              </div>
              <div class="pr-0">
                <!-- aggressive| lazy -->
                <ValidationProvider
                  mode="lazy"
                  vid="postal_code"
                  class="row col-10 pr-0 offset-2"
                  :name="$t('front_end.a035.label.ship_address.postal_code')"
                  :rules="
                    !isShopMode
                      ? `required|length:7|half_size_number`
                      : `length:7|half_size_number`
                  "
                  v-slot="{ errors, failedRules }"
                >
                  <input
                    :type="dynamicNumberType"
                    maxlength="7"
                    class="form-control col-5"
                    :pattern="dynamicPattern"
                    v-model.trim="ordererInformation.zip_code"
                    id="zip-code"
                  />
                  <button
                    class="col-3 offset-1 btn-custom mt-0"
                    type="button"
                    @click.prevent="searchAddress()"
                  >
                    {{ $t('front_end.a035.button.automatic_input_code') }}
                  </button>

                  <div class="inline-error-noti" v-if="failedRules.length">
                    {{ $t('front_end.a035.errors.postal_code.length') }}
                  </div>
                  <div
                    class="inline-error-noti"
                    v-else-if="failedRules.required"
                  >
                    {{ $t('front_end.a035.errors.postal_code.required') }}
                  </div>

                  <div
                    class="inline-error-noti"
                    v-else-if="failedRules.half_size_number"
                  >
                    {{
                      $t('front_end.a035.errors.postal_code.half_size_number')
                    }}
                  </div>
                  <div class="inline-error-noti" v-else>{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group">
              <div class="row col-10 pr-0 offset-2">
                <label>{{
                  $t('front_end.a035.label.ship_address.prefectures')
                }}</label>
                <span class="text-danger" v-if="!isShopMode">*</span>

                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.prefectures')"
                  rules="required"
                  v-slot="{ failedRules }"
                  v-if="!isShopMode"
                  class="w100"
                >
                  <div class="select-box">
                    <font-awesome-icon icon="angle-down" class="icon-select" />
                    <select
                      class="form-control"
                      v-model="ordererInformation.prefectures"
                      ref="prefecture"
                      id="prefectureSelect"
                    >
                      <option
                        v-for="(pref, index) in prefectureList"
                        :key="index"
                        >{{ pref }}</option
                      >
                    </select>
                  </div>
                  <p class="inline-error-noti" v-if="failedRules.required">
                    {{ $t('front_end.a035.validate.prefecture_required') }}
                  </p>
                </ValidationProvider>
                <div class="select-box" v-else>
                  <font-awesome-icon icon="angle-down" class="icon-select" />
                  <select
                    class="form-control"
                    v-model="ordererInformation.prefectures"
                    ref="prefecture"
                    id="prefectureSelect"
                  >
                    <option
                      v-for="(pref, index) in prefectureList"
                      :key="index"
                      >{{ pref }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row col-10 pr-0 offset-2">
                <label>{{
                  $t('front_end.a035.label.ship_address.city')
                }}</label>
                <span class="text-danger" v-if="!isShopMode">*</span>

                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.city')"
                  rules="required|full_size|max:100"
                  v-slot="{ errors }"
                  v-if="!isShopMode"
                  class="w100"
                >
                  <input
                    maxlength="100"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.city"
                  />
                  <span class="error-msg message-error-size" v-if="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.city')"
                  rules="full_size|max:100"
                  v-slot="{ errors }"
                  v-else
                  class="w100"
                >
                  <input
                    maxlength="100"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.city"
                  />
                  <span class="error-msg message-error-size" v-if="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="form-group">
              <div class="row col-10 pr-0 offset-2">
                <label>{{
                  $t('front_end.a035.label.ship_address.address_number')
                }}</label>
                <span class="text-danger" v-if="!isShopMode">*</span>

                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.address_number')"
                  rules="required|max:255"
                  v-slot="{ errors }"
                  v-if="!isShopMode"
                  class="w100"
                >
                  <input
                    maxlength="255"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.address"
                  />

                  <span class="error-msg message-error-size" v-if="errors">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.address_number')"
                  rules="max:255"
                  v-slot="{ errors }"
                  v-else
                  class="w100"
                >
                  <input
                    maxlength="255"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.address"
                  />

                  <span class="error-msg message-error-size" v-if="errors">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group">
              <div class="row col-10 pr-0 offset-2">
                <label>{{
                  $t('front_end.a035.label.ship_address.building_name')
                }}</label>

                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.ship_address.building_name')"
                  rules="max:255"
                  v-slot="{ errors }"
                  class="w100"
                >
                  <input
                    maxlength="255"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.buildingName"
                  />
                  <span class="error-msg message-error-size" v-if="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.company_name') }}</span>
              </div>

              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.company_name')"
                  rules="max:255"
                  v-slot="{ errors }"
                  class="w100"
                >
                  <input
                    maxlength="255"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.companyName"
                  />
                  <span class="error-msg message-error-size" v-if="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.department_name') }}</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a035.label.department_name')"
                  rules="max:255"
                  v-slot="{ errors }"
                  class="w100"
                >
                  <input
                    maxlength="255"
                    type="text"
                    class="form-control"
                    v-model.trim="ordererInformation.departmentName"
                  />
                  <span class="error-msg message-error-size" v-if="errors[0]">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{ $t('front_end.a035.label.comment') }}</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <textarea
                  rows="3"
                  class="form-control"
                  v-model.trim="ordererInformation.comment"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="content-footer-info">
            <button
              v-if="
                !isShopMode &&
                  ((null !== isReOrderApi && !isReOrderApi) || !reOrder)
              "
              class="col-md-4 col-5 btn-footer"
              type="submit"
              @click="changeActionTypeTemporary"
            >
              {{ $t('front_end.a035.button.temporarily_save') }}
            </button>
            <button
              class="col-md-4 col-5 btn-footer"
              type="submit"
              @click="changeActionTypeProceed"
            >
              {{ $t('front_end.a035.button.continue_order') }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <!-- modal action temp -->
    <fe-alert ref="modalActionTemp" :datas="dataAlert">
      <template v-slot:default>
        <div class="form-group text-left cursor-default px-3">
          <span v-html="dataAlert.text"></span>
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onModalActionTempConfirmYes"
          class="btn-dialog col-6 border-top border-right color-red"
        >
          {{ dataAlert.btn.yes }}
        </button>
        <button
          type="button"
          @click="onModalActionTempConfirmCancel"
          class="btn-dialog col-6 border-top border-left"
        >
          {{ dataAlert.btn.no }}
        </button>
      </template>
    </fe-alert>

    <!-- modal modalSendMailSuccess -->
    <fe-alert ref="modalSendMailSuccess" :datas="dataSendMailSucces">
      <template v-slot:default>
        <div class="form-group text-left cursor-default px-3">
          <span v-html="dataSendMailSucces.text"></span>
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onModaldataSendMailSuccesContinue"
          class="btn-dialog col-6 border-top border-right color-red"
        >
          {{ dataSendMailSucces.btn.yes }}
        </button>
        <button
          type="button"
          @click="onModaldataSendMailSuccesBackToTop"
          class="btn-dialog col-6 border-top border-left"
        >
          {{ dataSendMailSucces.btn.no }}
        </button>
      </template>
    </fe-alert>

    <router-view></router-view>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import api from '@/services/api'
import apiEndpoints from '@/services/apiEndpoints'
import { mapGetters, mapState } from 'vuex'
import FeAlert from '@/components/fe/common/FeAlert'
import deviceUtil from '@/utils/deviceUtil'
var md5 = require('md5')

// import _ from "lodash";
const ACTION_TYPE = {
  TEMPORARY: 'temporary',
  PROCEED: 'proceed',
}
export default {
  name: 'A035',
  components: {
    ValidationProvider,
    ValidationObserver,
    FeAlert,
  },
  mounted() {
    // console.log("this.userData", this.userData);
    if (!this.$route?.params?.hash) {
      this.ordererInformation.orderNo = this.userData?.order?.orderNo
      if (this.userData?.order?.ordererInformation) {
        // console.log(
        //   "this.userData.order.ordererInformation;",
        //   this.userData.order.ordererInformation
        // );
        this.ordererInformation = this.convertOrdererObjNormal(
          this.userData.order.ordererInformation
        )
      }
    }
    this.refreshIfNewOrder()
    this.$root.$on('header-back', this.backBtnHandle)
  },

  data() {
    return {
      isPhoneError: false,
      isComplete: false,
      isShowConfirm: false,
      isReOrderApi: null,
      errors: { phoneNumber: '', name: '', furigana_name: '' },
      ordererInformation: {
        orderNo: '',
        first_name: '',
        last_name: '',
        first_name_kana: '',
        last_name_kana: '',
        email: '',
        phone_number_first: '',
        phone_number_second: '',
        phone_number_third: '',
        zip_code: '',
        prefectures: '',
        city: '',
        address: '',
        buildingName: '',
        companyName: '',
        departmentName: '',
        comment: '',
      },
      dataAlert: {
        isShow: false,
        isShowClose: true,
        text: this.$t('front_end.a035.alert.text.temporarily_save'),
        btn: {
          yes: this.$t('front_end.a035.alert.button.temporarily_save'),
          no: this.$t('front_end.a035.alert.button.cancel'),
        },
        modalContentClass: 'width-md-a035 mx-auto',
        modalClass: 'pr-0',
        enterAlert: {
          label_first_button: '',
          label_second_button: '',
        },
      },

      dataSendMailSucces: {
        isShow: false,
        isShowClose: true,
        text: this.$t('front_end.a035.alert.text.send_mail_success'),
        btn: {
          yes: this.$t('front_end.a035.alert.button.continue'),
          no: this.$t('front_end.a035.alert.button.back_to_top'),
        },
      },
      actionType: '',
      postcardInfomation: [],
      isLoadingModal: false,
    }
  },
  async created() {
    //TODO REMOVE - DONE
    // this.makeDummy();

    this.prefectureList = this.$configFe.prefectures

    this.isShopMode = !!this.shopMode.shopName

    if (this.$route?.params?.hash) {
      this.caseFromEmail()
    }

    document.addEventListener('keydown', function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === 'input') {
        e.preventDefault()
      }
    })

    if (this.reOrder) {
      await this.getOrdererInfomation(this.newOrderNo)
    }
  },

  computed: {
    ...mapGetters(['shopMode', 'userData']),
    dynamicNumberType() {
      return deviceUtil.isPc() ? 'text' : 'number'
    },
    dynamicPattern() {
      return deviceUtil.isiOS() ? '\\d*' : '.*'
    },
    ...mapState({
      reOrder: (state) => state.userData.order.reOrder,
      newOrderNo: (state) => state.userData.order.orderNo,
      oldOrderInformation: (state) => state.userData.order.ordererInformation,
    }),
  },
  methods: {
    // showModalInMatTen() {
    //   this.$router.push({ name: "a040" });
    // },

    backBtnHandle() {
      let pushObj = {
        name: 'a030',
      }

      if (this.userData?.order?.isConinueFromTemporary) {
        pushObj.query = { oh: md5(this.newOrderNo) }
      }

      this.$router.push(pushObj)
    },

    refreshIfNewOrder() {
      if (
        this.oldOrderInformation &&
        this.newOrderNo !== this.oldOrderInformation?.orderNo
      ) {
        this.ordererInformation['orderNo'] = this.newOrderNo
        this.$store.commit('userData/SET_ORDER', {
          ordererInformation: this.ordererInformation,
          // thumbnailBackURL
        })
      }
    },
    async getOrdererInfomation(orderNo) {
      let oh = md5(orderNo)
      let tempInfomation = await api.post(apiEndpoints.getOrdererInfomation, {
        orderNo: oh,
      })
      if (
        tempInfomation &&
        tempInfomation.status == 200 &&
        tempInfomation.data?.ordererInformation
      ) {
        this.ordererInformation = this.convertOrdererObjNormal(
          tempInfomation.data.ordererInformation
        )
        // console.log("this.ordererInformation", this.ordererInformation);
        // console.log(" this.ordererInformation ", this.ordererInformation);
        if (this.ordererInformation.orderNo) {
          // save orderNo, ordererInformation, thumbnailBackURL to Vuex

          //let thumbnailBackURL = this.getImageBackFromOrderNoHashed();
          this.$store.commit('userData/SET_ORDER', {
            orderNo: this.ordererInformation.orderNo,
            ordererInformation: this.ordererInformation,
            // thumbnailBackURL
          })
        }
      }
    },
    async caseFromEmail() {
      let tempInfomation = await this.getTempInfomation(this.$route.params.hash)
      // console.log("tempInfomation", tempInfomation);
      // let tempInfomation = {};
      if (
        tempInfomation &&
        tempInfomation.status == 200 &&
        tempInfomation.data?.ordererInformation
      ) {
        let ordererInformation = tempInfomation.data.ordererInformation
        this.ordererInformation = this.convertOrdererObjNormal(
          ordererInformation
        )

        let reOrder = tempInfomation.data?.reorder
        let template = {
          photoOrPrint: ordererInformation?.photoOrPrint,
          templateId: ordererInformation?.templateId,
        }
        // 0:order mới、1:order lại
        this.isReOrderApi = !!reOrder

        // console.log("this.ordererInformation", this.ordererInformation);
        // console.log(" this.ordererInformation ", this.ordererInformation);
        if (this.ordererInformation.orderNo) {
          // save orderNo, ordererInformation, thumbnailBackURL to Vuex

          //let thumbnailBackURL = this.getImageBackFromOrderNoHashed();
          this.$store.commit('userData/SET_ORDER', {
            orderNo: this.ordererInformation.orderNo,
            ordererInformation: tempInfomation.data.ordererInformation,
            isConinueFromTemporary: true,
            reOrder: reOrder,
            // thumbnailBackURL
          })

          this.$store.commit('userData/SET_SELECTED', {
            definision: ordererInformation.definision,
            category: ordererInformation.category,
            template: template,
          })

          this.$store.commit('userData/SET_TEMPLATES', {
            templateActive: template,
          })
        }
      }
    },
    async getImageBackFromOrderNoHashed() {
      //CR :1pfwb8sZ
      // this.ordererInformation.orderNo = "020081301000125";
      let respPG = await api.post(apiEndpoints.productGenerate, {
        orderno: this.ordererInformation.orderNo,
      })

      if (respPG && respPG.data?.code && Number(respPG.data.code) === 200) {
        let respEdu = await api.post(apiEndpoints.editDataUploadUrl, {
          orderNo: this.ordererInformation.orderNo,
          filename: 'preview-image-' + this.ordererInformation.orderNo,
          accessType: 'preview',
        })

        // console.log("respEdu", respEdu);
        if (respEdu && respEdu.data?.url) {
          return respEdu.data.url
        }
      }
      return ''
    },

    async getTempInfomation(x) {
      return await api.post(apiEndpoints.continueOrder, {
        orderNo: x,
      })
    },
    saveData() {
      let {
        orderNo,
        first_name: ordererFirstName,
        last_name: ordererLastName,
        first_name_kana: kanaFirstName,
        last_name_kana: kanaLastName,
        email: mailAddress,
        phone_number_first: phone1,
        phone_number_second: phone2,
        phone_number_third: phone3,
        zip_code: postalCode,
        prefectures,
        city,
        address: streetAddress1,
        companyName,
        departmentName,
        comment,
        buildingName,
      } = this.ordererInformation
      let body = {
        ordererInformation: {
          orderNo,
          ordererFirstName,
          ordererLastName,
          kanaFirstName,
          kanaLastName,
          mailAddress,
          phone1,
          phone2,
          phone3,
          postalCode,
          prefectures,
          city,
          streetAddress1,
          companyName,
          departmentName,
          comment,
          buildingName,
        },
      }
      let r = {
        config: {
          data: JSON.stringify({
            ordererInformation: body.ordererInformation,
          }),
        },
      }

      // console.log("r", r);
      this.saveOrdererInfoToLocal(r)
      //if (r.config?.data) {
    },
    makeDummy() {
      this.ordererInformation = {
        orderNo: '2020070699999998',
        address: 'address 1',
        buildingName: ' buildingName  1  ',
        city: ' city 1',
        comment: ' comment 1',
        companyName: 'companyName 1',
        departmentName: 'departmentName 1',
        email: 'abc@gmail.com',
        first_name: 'カナ',
        first_name_kana: 'カナ',
        last_name: 'カナ',
        last_name_kana: 'カナ',
        phone_number_first: '123',
        phone_number_second: '1234',
        phone_number_third: '1234',
        prefectures: 'chi ba',
        zip_code: '0410251',
      }
    },
    onModalActionTempConfirmCancel() {
      this.$refs.modalActionTemp.hide()
    },
    async onModalActionTempConfirmYes() {
      if (this.isLoadingModal) {
        return
      }
      this.$refs.modalActionTemp.hide()
      this.isLoadingModal = true
      let isSuccessActionTemp = await this.saveInfoToDB()
      if (isSuccessActionTemp && isSuccessActionTemp.status == 200) {
        this.$refs.modalSendMailSuccess.show()
      } else {
        //TODO  Hiển thị thông tin lỗi, gián đoạn xử lý
      }
      this.isLoadingModal = false
    },

    /*
      dom to api
    */
    convertOrdererObjStd(data) {
      let {
        orderNo,
        first_name: ordererFirstName,
        last_name: ordererLastName,
        first_name_kana: kanaFirstName,
        last_name_kana: kanaLastName,
        email: mailAddress,
        phone_number_first: phone1,
        phone_number_second: phone2,
        phone_number_third: phone3,
        zip_code: postalCode,
        prefectures,
        city,
        address: streetAddress1,
        companyName,
        departmentName,
        comment,
        buildingName: streetAddress2,
      } = data

      let ordererInformation = {
        orderNo,
        ordererFirstName,
        ordererLastName,
        kanaFirstName,
        kanaLastName,
        mailAddress,
        phone1,
        phone2,
        phone3,
        postalCode,
        prefectures,
        city,
        streetAddress1,
        streetAddress2,
        companyName,
        departmentName,
        comment,
      }
      return ordererInformation
    },

    /*api to dom*/
    convertOrdererObjNormal(data) {
      let {
        orderNo,
        ordererFirstName: first_name,
        ordererLastName: last_name,
        kanaFirstName: first_name_kana,
        kanaLastName: last_name_kana,
        mailAddress: email,
        phone1: phone_number_first,
        phone2: phone_number_second,
        phone3: phone_number_third,
        postalCode: zip_code,
        prefectures,
        city,
        streetAddress1: address,
        streetAddress2: buildingName,
        companyName,
        departmentName,
      } = data
      let comment = data.comment ?? ''
      return {
        orderNo,
        first_name,
        last_name,
        first_name_kana,
        last_name_kana,
        email,
        phone_number_first,
        phone_number_second,
        phone_number_third,
        zip_code,
        prefectures,
        city,
        address,
        companyName,
        departmentName,
        comment,
        buildingName,
      }
    },
    async saveInfoToDB() {
      let ordererInformation = this.convertOrdererObjStd(
        this.ordererInformation
      )
      let body = {
        actionType: this.actionType,
        ordererInformation,
      }
      let respInputInfo = null

      try {
        respInputInfo = await api.post(
          apiEndpoints.inputOrdererInformation,
          body
        )
      } catch (error) {
        //
      }
      return respInputInfo
    },
    changeActionTypeTemporary() {
      this.changeActionType(ACTION_TYPE.TEMPORARY)
    },

    changeActionType(t) {
      this.actionType = t
      //this.onClickAction();
    },

    changeActionTypeProceed() {
      this.changeActionType(ACTION_TYPE.PROCEED)
    },
    onModaldataSendMailSuccesContinue() {
      this.$refs.modalSendMailSuccess.hide()
    },
    onModaldataSendMailSuccesBackToTop() {
      this.$refs.modalSendMailSuccess.hide()
      this.$router.push({ name: 'a005' })
    },
    async searchAddress() {
      let isOk = false

      if (!this.ordererInformation.zip_code) {
        if (!this.isShopMode) {
          this.$refs.form.setErrors({
            postal_code: this.$t('front_end.a035.errors.postal_code.required'),
          })
        }
      } else if (this.ordererInformation.zip_code.length === 7) {
        isOk = true
      }

      if (isOk) {
        try {
          let result = await api.post(apiEndpoints.searchAddress, {
            postalCode: this.ordererInformation.zip_code,
          })
          if (
            result &&
            result.data &&
            result.data.address &&
            result.data.address.prefectures
          ) {
            this.ordererInformation.city = result.data.address.city
            this.ordererInformation.prefectures =
              result.data.address.prefectures
            this.ordererInformation.address = result.data.address.townArea
          }
        } catch (e) {
          // console.log(e);
        }
      }
    },
    async validateForm() {
      this.errors.phoneNumber = ''
      let formValid = await this.$refs.form.validate()
      let isValidateCustom = this.validateCustom()
      let isValidePhoneLength = this.validatePhoneLength()
      return formValid && isValidateCustom && isValidePhoneLength
    },
    validatePhoneLength() {
      let isValidPhone = true
      let total =
        this.ordererInformation.phone_number_first.length +
        +this.ordererInformation.phone_number_second.length +
        +this.ordererInformation.phone_number_third.length

      if (total < 10 || total > 11) {
        this.isPhoneError = true
        isValidPhone = false
        this.errors.phoneNumber = this.$t(
          'front_end.a035.validate.phone_number_limit'
        )
      } else {
        isValidPhone = true
      }

      return isValidPhone
    },
    async validateCustom() {
      let providerName = null
      if (
        this.$refs.last_name?.errors &&
        this.$refs.last_name.errors.length > 0
      ) {
        providerName = this.$refs.last_name.failedRules
      } else if (
        this.$refs.first_name?.errors &&
        this.$refs.first_name.errors.length > 0
      ) {
        providerName = this.$refs.first_name.failedRules
      }

      let providerFuri = null
      if (
        this.$refs.last_name_furigana?.errors &&
        this.$refs.last_name_furigana.errors.length > 0
      ) {
        providerFuri = this.$refs.last_name_furigana.failedRules
      } else if (
        this.$refs.first_name_furigana?.errors &&
        this.$refs.first_name_furigana.errors.length > 0
      ) {
        providerFuri = this.$refs.first_name_furigana.failedRules
      }

      let providerPhone = null
      if (
        this.$refs.phoneNumberFirst?.errors &&
        this.$refs.phoneNumberFirst.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberFirst.failedRules
      } else if (
        this.$refs.phoneNumberSecond?.errors &&
        this.$refs.phoneNumberSecond.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberSecond.failedRules
      } else if (
        this.$refs.phoneNumberThird?.errors &&
        this.$refs.phoneNumberThird.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberThird.failedRules
      }

      const errorMes = {
        name: {
          required:
            this.$t('front_end.a035.label.name') +
            this.$t('front_end.a035.validate.required'),
          full_size: this.$t('front_end.a035.validate.name_format'),
        },
        furigana_name: {
          required:
            this.$t('front_end.a035.label.name_furigana') +
            this.$t('front_end.a035.validate.required'),
          full_size_katakana:
            this.$t('front_end.a035.label.name_furigana') +
            this.$t('front_end.a035.validate.name_furigana_format'),
        },

        phone: {
          required:
            this.$t('front_end.a095.phone_number') +
            this.$t('front_end.a035.validate.required'),
          min:
            this.$t('front_end.a095.phone_number') +
            this.$t('front_end.a035.validate.length'),
          half_size_number:
            this.$t('front_end.a095.phone_number') +
            this.$t('front_end.a035.validate.number_format'),
        },
      }

      if (providerName) {
        if (providerName.required) {
          this.errors.name = errorMes.name.required
        } else if (providerName.full_size) {
          this.errors.name = errorMes.name.full_size
        }
      } else {
        this.errors.name = ''
      }

      if (providerFuri) {
        if (providerFuri.required) {
          this.errors.furigana_name = errorMes.furigana_name.required
        } else if (providerFuri.full_size_katakana) {
          this.errors.furigana_name = errorMes.furigana_name.full_size_katakana
        }
      } else {
        this.errors.furigana_name = ''
      }
      if (providerPhone) {
        if (providerPhone.required) {
          this.errors.phoneNumber = errorMes.phone.required
        } else if (providerPhone.min) {
          this.errors.phoneNumber = errorMes.phone.min
        } else if (providerPhone.half_size_number) {
          this.errors.phoneNumber = errorMes.phone.half_size_number
        }
      }

      if (this.errors) {
        return false
      }
      return true
    },
    async onClickAction() {
      if (this.isLoadingModal) {
        return ''
      }
      this.isLoadingModal = true
      let formValidate = await this.validateForm()
      // console.log("onClickAction formValidate", formValidate);

      if (formValidate) {
        if (this.actionType == ACTION_TYPE.TEMPORARY) {
          this.$refs.modalActionTemp.show()
        } else if (this.actionType == ACTION_TYPE.PROCEED) {
          // console.log("this.actionType", this.actionType);

          let responseActionProceed = null
          try {
            responseActionProceed = await this.saveInfoToDB()
            // console.log("responseActionProceed", responseActionProceed);
          } catch (error) {
            //
          }

          if (
            responseActionProceed.status == 200 &&
            responseActionProceed.data
          ) {
            this.saveOrdererInfoToLocal(responseActionProceed)

            //{"addressPrintExpiration":1607612400}
            let { addressPrintExpiration } = responseActionProceed.data

            // console.log("addressPrintExpiration", addressPrintExpiration);
            // TH unixtime trả về ở respons >= giờ hiện tại?? nani???
            if (
              addressPrintExpiration <=
              Math.round(this.$moment().valueOf() / 1000)
            ) {
              if (this.isShopMode) {
                //open bring in
                this.$router.push({ name: "a045" });
              } else {
                this.$router.push({ name: 'a060' })
              }
            } else {
              //TH unixtime trả về ở respons < giờ hiện tại
              //modal confirm In nguoi nhan / Khong in nguoi nhan
              // this.$refs.modalActionProceed.show();
              this.$router.push({ name: 'a040' })
            }
          }
        }
      }
      this.isLoadingModal = false
    },
    saveOrdererInfoToLocal(r) {
      if (r.config?.data) {
        let { ordererInformation } = JSON.parse(r.config.data)
        this.$store.commit('userData/SET_ORDER', { ordererInformation })
      }
    },
  },
  beforeDestroy() {
    this.$refs.modalSendMailSuccess.hide()
    this.$refs.modalActionTemp.hide()
    this.$root.$off('header-back', this.backBtnHandle)
  },
}
</script>

<style
  lang="css"
  scoped
  src="../../assets/css/userInfoOrder/userInfoOrder.css"
></style>

<style scoped>
.message-error-size,
.inline-error-noti,
.message-error {
  margin: 0px;
  font-size: 12px;
}
.inline-error-noti {
  margin: 0px;
  width: 100%;
}

.inline-error-noti {
  color: #dd0017;
}
@media screen and (max-width: 768px) {
  .message-error-size,
  .inline-error-noti,
  .message-error {
    font-size: 11px;
  }
}
.form-control {
  font-size: 0.9rem;
  line-height: 1.6;
}
.btn-custom {
  max-height: 37px;
  line-height: 22px;
  min-width: 100px;
}
.w100 {
  width: 100%;
}
.pd-0 {
  padding: 0px !important;
}

.icon-select {
  color: red;
  position: absolute;
  right: 0;
  font-size: 15px;
  top: 0;
  height: 100%;
  margin: 0 7px;
  z-index: 1;
  pointer-events: none;
}
select#prefectureSelect {
  position: relative;
  display: block;
  background: transparent;
}

@media screen and (min-width: 768px) {
  .icon-select {
    font-size: 20px;
    margin: 0 10px;
  }
  input.form-control,
  select.form-control {
    height: calc(1.6em + 0.75rem) !important;
  }
}

@media screen and (min-width: 1024px) {
  .icon-select {
    font-size: 25px;
  }
}

@media screen and (max-width: 480px) {
  .btn-custom {
    padding: 5px;
    max-height: 33px;
  }
}
@media screen and (min-width: 300px) {
  input.form-control {
    height: calc(1.6em + 0.75rem - 5px);
  }
}

.color-red {
  color: red;
}
.close-dialog {
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>
